var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Data } from './data';
import { ItemGroup } from './item-group';
var Category = /** @class */ (function (_super) {
    __extends(Category, _super);
    function Category() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.class = "Category";
        _this.groupIds = [];
        _this.groups = [];
        return _this;
    }
    Category.prototype.toProperty = function (name, value) {
        switch (name) {
            case "groups":
                value = Data.toDataArray(ItemGroup, value);
                break;
            default:
                value = _super.prototype.toProperty.call(this, name, value);
                break;
        }
        return value;
    };
    Object.defineProperty(Category.prototype, "displayName", {
        get: function () {
            if (this.prefix)
                return this.prefix + this.name;
            return this.name;
        },
        enumerable: true,
        configurable: true
    });
    Category.toCategoryData = function (category) {
        var json = {};
        json["id"] = category.id;
        json["name"] = category.name;
        // json["cGroupId"] = category.cGroupId;
        // json["departmentId"] = category.departmentId;
        return json;
    };
    return Category;
}(Data));
export { Category };
//# sourceMappingURL=category.js.map